export default {
      id: "covid-outline-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#covid-outline",
      toString: function () {
        return this.url;
      }
    }